import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Input, Row, Space, Table } from "antd";
import moment from 'moment-jalaali';
import { ZoomInOutlined } from "@ant-design/icons";
import InsuranceDetails from "../shared/insuranceDetails/InsuranceDetails";
import strings from '../../utils/strings';
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";
import { usePersistedStore } from '../../store/persisted-store';

import StringHelper from "../helpers/StringHelper";

export const WaitingToReturn = () => {
    const reports = useReportsStore()
    const general = useGeneralStore();
    const { business } = usePersistedStore()
    const loading = reports.returnedReports.loading
    const data = reports.returnedReports.returnedSettlementReports;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;

    const [requestId, setRequestId] = useState();
    const [searchValue, setSearchValue] = useState("");
    const [filterData, setFilterData] = useState([]);

    useEffect(() => {
        if (token)
            reports.getWaitingForSettlementReturnedReports();
    }, [token])

    useEffect(() => {
        setFilterData(data)
    }, [data]);

    function handlePaste(event) {
        let paste = (event.clipboardData || window.clipboardData).getData("text");
        paste = paste.split("|").join(",");
        setSearchValue(paste)
    }


    useEffect(() => {
        if (searchValue === "") return setFilterData(data)
    }, [searchValue]);

    const searchHandlerInput = (event) => {
        const { value } = event.target;
        setSearchValue(value);
        const englishNum = StringHelper.getEnglishNum(value)
        if (value) {
            const filtered = data && data.filter((item) => {
                return item?.DestinationShebaOwner?.includes(value) ||
                    item?.MobileNumber?.includes(Number(englishNum)) ||
                    item?.BankToken?.includes(value) ||
                    item?.BankTrackingCode?.includes(value)
            }
            )
            if (filtered) setFilterData(filtered)
        }
    }
    const columns = [

        {
            title: "جزئیات بیمه نامه",
            dataIndex: "operation",
            key: "operation",
            width: 95,
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">
                        <Button type='link' onClick={() => {
                            reports.getInsuranceDetailsInfo(record.InsuranceRequestId)
                            setRequestId(record.InsuranceRequestId);
                            general.ToggleInsuranceDetailsModal();
                        }
                        }><ZoomInOutlined /></Button>
                    </Space>
                ),
        },
        {
            title: 'نام گیرنده',
            dataIndex: 'DestinationShebaOwner',
            key: 'DestinationShebaOwner',
            width: 200,
        },
        {
            title: 'مبلغ(ریال)',
            dataIndex: 'Amount',
            key: 'Amount',
            width: 200,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: 'شناسه درخواست',
            dataIndex: 'InsuranceRequestId',
            key: 'InsuranceRequestId',
            width: 200,
        },
        {
            title: 'شماره الحاقیه',
            dataIndex: 'EndorsementId',
            key: 'EndorsementId',
            width: 200,
            render: EndorsementId => (EndorsementId === 0 || EndorsementId === null) ? '' : EndorsementId,
        },
        {
            title: 'مقصد (شماره حساب یا شبا)',
            dataIndex: 'DestinationSheba',
            key: 'DestinationSheba',
            width: 100,
        },
        {
            title: 'توضیحات واحد فروش',
            dataIndex: 'DescriptionOfSalesUnit',
            key: 'DescriptionOfSalesUnit',
            width: 200,
        },

        {
            title: 'شرح',
            dataIndex: 'Description',
            key: 'Description',
            width: 185,
        },
        {
            title: 'شماره همراه کاربر',
            dataIndex: 'MobileNumber',
            key: 'MobileNumber',
            width: 185,
        },
        {
            title: "تاریخ خرید",
            dataIndex: "BuyDate",
            key: "BuyDate",
            width: 200,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.BuyDate ? first = a.BuyDate : first = '';
                b.BuyDate ? second = b.BuyDate : second = '';
                return first.localeCompare(second)
            },
            render: data => data && (data.BuyDate === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
        },
        {
            title: "تاریخ ارجاع به مالی",
            dataIndex: "SettlementCreationTime",
            key: "SettlementCreationTime",
            width: 200,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.SettlementCreationTime ? first = a.SettlementCreationTime : first = '';
                b.SettlementCreationTime ? second = b.SettlementCreationTime : second = '';
                return first.localeCompare(second)
            },
            render: data => data && (data.SettlementCreationTime === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
        },
        {
            title: "تاریخ ثبت عودت",
            dataIndex: "PaymentCreationTime ",
            key: "PaymentCreationTime ",
            width: 200,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.PaymentCreationTime ? first = a.PaymentCreationTime : first = '';
                b.PaymentCreationTime ? second = b.PaymentCreationTime : second = '';
                return first.localeCompare(second)
            },
            render: data => data && (data.PaymentCreationTime === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
        },

        {
            title: "کد رهگیری بانک",
            dataIndex: 'BankTrackingCode',
            key: 'BankTrackingCode',
            width: 200,
        },
        {
            title: 'شماره تراکنش',
            dataIndex: 'BankToken',
            key: 'BankToken',
            width: 400,
        }
    ];

    return (
        <Card>
            <Row justify="space-between">
                <div style={{ marginBottom: 16, fontSize: 16 }}>گزارش های در انتظار عودت</div>
                <button
                    onClick={() => reports.getWaitingForSettlementReturnedReports()}
                    style={{
                        float: "left",
                        padding: "6px 24px",
                        height: 40,
                    }}

                    type="primary" className="btn btn-primary waves-effect waves-light"
                    htmlType='submit'>بروز رسانی لیست&nbsp;&nbsp;&nbsp;
                    <i className={loading ? "bx bx-loader bx-spin" : "fas fa-sync-alt"}></i>
                </button>
            </Row>
            <Row style={{ marginBottom: "-20px" }}>
                <Col span={16}>
                    <Form.Item
                        onKeyPress={(e) => (e.key === 'Enter' && "")}
                        name="search" label="جست و جو:"
                        className="search-lable">
                        <Input
                            value={searchValue}
                            onPaste={handlePaste}
                            onChange={e => searchHandlerInput(e)}
                            className="table-search"
                            placeholder="بر اساس نام گیرنده، شماره همراه کاربر و شماره تراکنش"
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Table
                loading={loading}
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                size="small"
                bordered
                columns={columns}
                rowKey="Id"
                scroll={true}
                dataSource={[...filterData] && [...filterData]}
                rowClassName={(record) => ((record.EndorsementId === 0 || record.EndorsementId === null) ? "none" : "highlight")}
            />
            <InsuranceDetails requestId={requestId} />
        </Card>
    )
}
